import PeopleSharp from "@material-ui/icons/PeopleSharp";
import Flight from "@material-ui/icons/Flight";
import HelpOutline from "@material-ui/icons/HelpOutline";
import SupervisedUserCircleIcon from "@material-ui/icons/SupervisedUserCircle";
import PaymentIcon from "@material-ui/icons/Payment";
import DashboardIcon from "@material-ui/icons/Dashboard";
import Category from "@material-ui/icons/Category";
import ManageCustomers from "../views/BerPay/ManageCustomers";
import ManageOfficers from "../views/BerPay/ManageCustomOfficers";
import ManageCategory from "../views/BerPay/ManageCategories";
import ManageQuestions from "../views/BerPay/ManageQuestions";
import AddNewUser from "../views/BerPay/viewcustomers";

import Viewcategories from "../views/BerPay/Viewcategories";
import viewQuestion from "../views/BerPay/Viewquestions";
import viewFlight from "../views/BerPay/Viewflights";
import manageFlights from "../views/BerPay/ManageFlights";
import ManageFlights from "../views/BerPay/ManageFlights";
import ManageDeclarations from "../views/BerPay/ManageDeclarations";
import viewDeclarations from "../views/BerPay/viewdeclarations";
import ManagePayment from "../views/BerPay/ManagePayment";
import viewOfficer from "../views/BerPay/viewOfficer";
import DetailsIcon from "@material-ui/icons/Details";
import addcustomer from "../views/BerPay/addcustomer";
import ManageTransaction from "../views/BerPay/ManageTransaction";
import ReceiptIcon from "@material-ui/icons/Receipt";
import MenuBookIcon from "@material-ui/icons/LibraryBooks";
import ManageStaticContent from "../views/BerPay/ManageStaticContent";
import addcustomerofficer from "../views/BerPay/addcustomerofficer";
import ManagePaidDeclaration from "../views/BerPay/ManagePaidDeclaration";
import DashBoard from "../views/BerPay/dashboard";
import { FaUsers, FaUserShield } from "react-icons/fa";
import {
  MdDashboard,
  MdDeleteSweep,
  MdAttachMoney,
  MdAccountBalance,
  MdQuestionAnswer,
  MdAdminPanelSettings,
} from "react-icons/md";
import { ImStatsDots } from "react-icons/im";
import { AiOutlineBlock } from "react-icons/ai";
import { GrTransaction } from "react-icons/gr";

import ManageAdminOfficer from "../views/BerPay/ManageAdminOfficer";

var dashRoutes = [
  // {
  //   path: "/admin/viewTransactions",
  //   name: "Transactions",
  //   hide: false,
  //   icon: EventTwoTone,
  //   component: ViewTransactions,
  // },
  // {
  //   path: "/admin/dashboard",
  //   name: "Dashboard",
  //   hide: false,
  //   icon: ImStatsDots,
  //   component: DashBoard,
  // },
  {
    path: "/admin/manageCustomers",
    name: "Customers",
    hide: false,
    icon: FaUsers,
    component: ManageCustomers,
    count: true,
    subname: "customer",
  },
  // {
  //   path: "/admin/manageCustomOfficers",
  //   name: "Custom Officers",
  //   hide: false,
  //   icon: FaUserShield,
  //   component: ManageOfficers,
  //   count: true,
  //   subname: "custom",
  // },
  // {
  //   path: "/admin/adminOfficers/view",
  //   name: `Officer Details`,
  //   hide: true,
  //   component: viewOfficer,
  // },
  // {
  //   exact: true,
  //   path: "/admin/adminOfficers",
  //   name: "Admin Officers",
  //   hide: false,
  //   icon: MdAdminPanelSettings,
  //   component: ManageAdminOfficer,
  // },

  // {
  //   path: "/admin/manageDeclarations",
  //   name: "Declarations",
  //   hide: false,
  //   icon: MdDashboard,
  //   component: ManageDeclarations,
  //   count: true,
  //   subname: "declaration",
  // },
  {
    path: "/admin/managepayment",
    name: "Payments",
    hide: false,
    icon: GrTransaction,
    component: ManagePayment,
    subname: "payment",
  },
  {
    path: "/admin/transaction",
    name: "Transaction Fees",
    hide: false,
    icon: MdAttachMoney,
    component: ManageTransaction,
  },
  // {
  //   path: "/admin/manageCategories",
  //   name: "Declaration Categories",
  //   hide: false,
  //   icon: AiOutlineBlock,
  //   component: ManageCategory,
  // },
  // {
  //   path: "/admin/manageFlights",
  //   name: "Flights",
  //   hide: false,
  //   icon: Flight,
  //   component: ManageFlights,
  // },
  // {
  //   path: "/admin/manageQuestions",
  //   name: "Questions & Answers",
  //   hide: false,
  //   icon: MdQuestionAnswer,
  //   component: ManageQuestions,
  // },
  // {
  //   path: "/admin/deletedeclarationrequests",
  //   name: "Delete Requests",
  //   hide: false,
  //   icon: MdDeleteSweep,
  //   component: ManagePaidDeclaration,
  //   count: true,
  //   subname: "delete",
  // },

  {
    path: "/admin/staticContent",
    name: "Legal & Privacy",
    hide: false,
    icon: MdAccountBalance,
    component: ManageStaticContent,
  },

  {
    path: "/admin/addCustomer",
    name: "Add Customer",
    hide: true,
    icon: PeopleSharp,
    component: addcustomer,
  },

  // {
  //   path: '/admin/addOfficer',
  //   name : "Add officer",
  //   hide:true,
  //   icon:SupervisedUserCircleIcon,
  //   component: addcustomerofficer
  // },

  // {
  //   path: "/admin/manageCustomOfficers",
  //   name: "Manage Custom Officers",
  //   hide: false,
  //   icon: PeopleSharp,
  //   component: ManageOfficers,
  // },

  {
    path: "/admin/viewCategory/:id",
    name: "View Category",
    hide: true,
    icon: PeopleSharp,
    component: Viewcategories,
  },
  {
    path: "/admin/editCategory/:id",
    name: "Edit Category",
    hide: true,
    icon: PeopleSharp,
    component: Viewcategories,
  },
  {
    path: "/admin/addCategory/",
    name: "Add Category",
    hide: true,
    icon: PeopleSharp,
    component: Viewcategories,
  },

  // {
  //   path: "/admin/viewQuestion/:id",
  //   name: "View Question",
  //   hide: true,
  //   icon: PeopleSharp,
  //   component: viewQuestion,
  // },
  // {
  //   path: "/admin/editQuestion/:id",
  //   name: "Edit Question",
  //   hide: true,
  //   icon: PeopleSharp,
  //   component: viewQuestion,
  // },
  // {
  //   path: "/admin/addQuestion/",
  //   name: "Add Question",
  //   hide: true,
  //   icon: PeopleSharp,
  //   component: viewQuestion,
  // },

  {
    path: "/admin/viewDeclaration/:id",
    name: "View Declaration",
    hide: true,
    icon: DetailsIcon,
    component: viewDeclarations,
  },

  {
    path: "/admin/viewFlight/:id",
    name: "View Flight",
    hide: true,
    icon: PeopleSharp,
    component: viewFlight,
  },
  {
    path: "/admin/editFlight/:id",
    name: "Edit Flight",
    hide: true,
    icon: PeopleSharp,
    component: viewFlight,
  },
  {
    path: "/admin/addFlight/",
    name: "Add Flight",
    hide: true,
    icon: PeopleSharp,
    component: viewFlight,
  },
  {
    path: "/admin/viewuser",
    name: "Customer Detail",
    hide: true,
    icon: PeopleSharp,
    component: AddNewUser,
  },
  {
    path: "/admin/viewofficer",
    name: "Officer Detail",
    hide: true,
    icon: PeopleSharp,
    component: viewOfficer,
  },

  //

  //
  {
    redirect: true,
    path: "/admin",
    pathTo: "/admin/pages/login-page",
    name: "Login",
  },
  { redirect: true, path: "/", pathTo: "/admin/pages", name: "Login" },
];
export default dashRoutes;
